/** A custom channel name: lowercase letters, digits, `_` and `-`, 1 to 32 characters. */
export const CUSTOM_CHANNEL_PATTERN = /^[a-z0-9_-]{1,32}$/

// Phone-only contacts get an address that can never be delivered to.
export const CUSTOM_CONTACT_EMAIL_DOMAIN = "custom.invalid"

/** The synthetic address for a contact known only by an external id, such as a phone number. */
export function customContactEmail(externalId: string): string {
	const local = externalId
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.slice(0, 60)
	return `${local || "contact"}@${CUSTOM_CONTACT_EMAIL_DOMAIN}`
}

export function isCustomContactEmail(
	email: string | null | undefined,
): boolean {
	return !!email && email.endsWith(`@${CUSTOM_CONTACT_EMAIL_DOMAIN}`)
}

const KNOWN_CUSTOM_CHANNELS: Record<string, string> = {
	whatsapp: "WhatsApp",
	sms: "SMS",
	messenger: "Messenger",
	instagram: "Instagram",
	telegram: "Telegram",
	viber: "Viber",
	line: "LINE",
	wechat: "WeChat",
}

/** "whatsapp" -> "WhatsApp", "sms" -> "SMS", any other slug title-cased. */
export function customChannelLabel(channel: string | null | undefined): string {
	if (!channel) return "Custom channel"
	return (
		KNOWN_CUSTOM_CHANNELS[channel] ??
		channel
			.split(/[-_]/)
			.filter(Boolean)
			.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
			.join(" ")
	)
}
